/**
 * api/workflowConfig.js — SuperAdmin client for Module 2 routes.
 *
 * Surfaces:
 *   GET  /super-admin/workflow-config/validation-rules
 *   GET  /super-admin/orgs/:accountId/workflow-config
 *   PATCH /super-admin/orgs/:accountId/workflow-config
 */
import api from '../lib/api';

const base = '/super-admin';

export const fetchValidationRules = () =>
  api.get(`${base}/workflow-config/validation-rules`).then((r) => r.data);

export const fetchWorkflowConfig = (accountId) =>
  api.get(`${base}/orgs/${accountId}/workflow-config`).then((r) => r.data);

export const patchWorkflowConfig = (accountId, patch) =>
  api.patch(`${base}/orgs/${accountId}/workflow-config`, patch).then((r) => r.data);
